module.exports = __webpack_public_path__ + "img/donation.70c79eae.png";